import { Component, Inject, ViewChild } from "@angular/core";
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import {  MatDialogRef, MAT_DIALOG_DATA as MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Select, Store } from "@ngxs/store";
import { WorkHoursList,Family,  TeamWorkingHours, TeamMember, ProviderUser, SaveTeamWorkHours, SavePractitionerGroup, PractitionerGroupEntity, SaveTeamMembers, PractitionerGroupStateModel, CommonService, GetPractitionerGroups, dayTimeToSeconds, DayOfWeek, GetServiceLevels, ServiceLevel , ServiceLevelService, CompassStateModel, GetTeamsForUser, GroupUser} from 'huddyapi';
import { SavedProvider } from "../../settings/settings.component";
import { MatDatepicker, MatDatepickerInputEvent } from "@angular/material/datepicker";
import { interval, Observable, Subscription, take } from "rxjs";
import { MatTable } from "@angular/material/table";
import { CommunityConfigService } from "../../services/community-config.service";



@Component({
  selector: 'edit-practitioner-group-dialog',
  templateUrl: 'edit-practitioner-group-dialog.component.html',
  styleUrls: ["./edit-practitioner-group-dialog.component.scss"]
})
export class EditPractitionerGroupDialog  {
  @ViewChild(MatTable) table: MatTable<any>;
  @Select(state => state.practitionerGroupState) practitionerGroupState$;
  practitionerGroupSubscription : Subscription;
  currentSaved : PractitionerGroupEntity;
  families : Family[] = [];
  @Select(state => state.compassState) serviceLevelsState$: Observable<CompassStateModel>;
  serviceLevelsSubscription : Subscription;
  serviceLevels : ServiceLevel[];
  userRows : UserRow[];
  userFormArray : UntypedFormArray = this.formBuilder.array([]);
  saveFired : boolean =false;
  teamsFired : boolean = false;
  panel : number = 0;
  @ViewChild('picker', { static: true }) _picker: MatDatepicker<Date>;
  edited : PractitionerGroup;
  provider : SavedProvider;
  viewInited : boolean = false;
  teamMembers : TeamMember[];
  teamRoles : string[] = ['Not In Team', 'Coordinator', 'Scheduler', 'Worker', 'Evaluator', 'Project Lead', 'Recruiter'];
  displayColumns : string[] = ['email', 'teamRole', 'capabilities'];
  closed : boolean = false;

  userServicesCache : Map<string, ServiceLevelService[]> = new Map();
  allDays : string[] = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
  userSelectedShadow : string;
  familyServices : ServiceLevelService[];
  workHours : string[] = ['12am', '12:30am', '1am', '1:30am', '2am', '2:30am', '3am','3:30am', '4am', '4:30am', '5am', '5:30am', '6am', '6:30am', '7am', '7:30am', '8am', '8:30am', '9am', '9:30am',  '10am', '10:30am', '11am', '11:30am',  '12pm', '12:30pm', '1pm', '1:30pm', '2pm', '2:30pm', '3pm','3:30pm', '4pm', '4:30pm', '5pm', '5:30pm', '6pm', '6:30pm', '7pm', '7:30pm', '8pm', '8:30pm', '9pm', '9:30pm',  '10pm', '10:30pm', '11pm', '11:30pm'];
  public CLOSE_ON_SELECTED = false;
  public init = new Date();
  public resetModel = new Date(0);

  practitionerGroupForm = this.formBuilder.group({
    name: ['', [Validators.required, Validators.maxLength(50)]],
    description:  ['', [Validators.required, Validators.maxLength(255)]],
    users:  [],
    coordinator :  ['', [Validators.required]],
    workDays : [['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY'], [Validators.required]],
    startTime : ['9am', [Validators.required]],
    endTime : ['5pm', [Validators.required]],
    holidays : [[], [Validators.required]],
    userInfo: this.userFormArray
    // user :  '',
    // userServices : [[], []]
});

  constructor(
    public dialogRef: MatDialogRef<EditPractitionerGroupDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder : UntypedFormBuilder,
    private common : CommonService,
    public store : Store
  )
  {
    console.log('data', data);
    this.practitionerGroupForm.setValue({
      name: data.name ?? '',
      description: data.description ?? '',
      users : data.users ?? [],
      coordinator: data.coordinator ?? '',
      workDays : data.workDays ?? [],
      startTime : data.startTime ?? '',
      endTime : data.endTime ?? '',
      holidays : data.holidays ?? [],
      userInfo : []
    });
    console.log('Workdays', this.practitionerGroupForm.value.workdays);
    this.edited = {
      id : data.id,
      name: data.name ?? '', 
      description: data.description ?? '',
      users : data.users ?? [],

    };

    this.provider = this.data.provider;
    console.log('provider=', this.provider, data.teamMembers);
    this.teamMembers = data.teamMembers;
    for (let tm of this.teamMembers) {
      this.userServicesCache.set(tm.email, tm.capabilities);
    }

    console.log('edited=', this.edited,  this.userServicesCache);


  }  
  

  ngAfterViewInit() {
    console.log('view inited');
    this.  serviceLevelsSubscription  = this.serviceLevelsState$.subscribe((compassState: CompassStateModel) => {
      // console.log(compassState);
      if (compassState?.serviceLevels ) {
          this.serviceLevels = [].concat(compassState.serviceLevels);
          this.familyServices = this.getServices();
          console.log('familyServices/capabilities', this.serviceLevels, this.familyServices);
          
          this.buildUserRows();
      }
    
      // console.log(this.serviceLevels, this.serviceLevels.map(g => g.name));   
    });
  }

  ngOnInit(): void {
    this.teamsFired = false;
    this.closed = false;
    console.log('on init');

    this.saveFired = false;
    this.  practitionerGroupSubscription  = this.practitionerGroupState$.subscribe((practitionerGroupState: PractitionerGroupStateModel) => {
      console.log(practitionerGroupState);
      if (practitionerGroupState && practitionerGroupState.currentGroup && this.saveFired && !this.teamsFired) {
        this.teamsFired = true;
        console.log('got saved group', practitionerGroupState.currentGroup);
        this.store.dispatch(new SaveTeamMembers(this.getTeamMembers(practitionerGroupState.currentGroup)));
        this.store.dispatch(new SaveTeamWorkHours(this.getWorkHours(practitionerGroupState.currentGroup)));
        this.close();
      }
     
    });

    console.log(this.provider);
    this.store.dispatch(new GetServiceLevels(this.provider.id));
  }

  buildUserRows() {
    if (this.closed) {
      return;
    }
    console.log('buildUserRows', this.familyServices, this.provider.savedUsers);
    this.userRows = this.provider.savedUsers.map(user => {
      const teamMember : TeamMember = this.teamMembers.find(tm => tm.email === user.email); 
      const capabilities : ServiceLevelService[] = [];
      const userServices : ServiceLevelService[] = this.userServicesCache.get(user.email) ?   
      this.userServicesCache.get(user.email) : [];
      for (let s of userServices) {
        let familyService : ServiceLevelService = this.familyServices.find(fs => fs.name === s.name);
        if (familyService) {
          capabilities.push(familyService);
        }
      }
      let teamRole = 'Not In Team';
      if (teamMember && teamMember.teamRole && teamMember.teamRole != '') {
          teamRole = this.toUserValue(teamMember.teamRole);
      }  
      console.log('capabilities', teamMember, this.familyServices, capabilities);
      return  ({
        email: user.email,
        teamRole : teamRole,
        capabilities : capabilities
      });
    });
    this.userRows.sort((a, b) => {
      if (a.teamRole && !b.teamRole) 
        return 1;
      if (!a.teamRole && b.teamRole)
        return -1;
      return 0;
    });
    console.log('buildUserRows', this.userRows);
    this.userFormArray.clear();
    if (this.table && this.userRows)
      this.table.renderRows();
    for (let user of this.userRows) {
      let group : UntypedFormGroup = undefined;
      let formGroupArr = this.userFormArray.controls as UntypedFormGroup[]
      for (let i = 0; i < formGroupArr.length; i++) {
        const formGroup = formGroupArr[i];
        if (formGroup.controls['email'].value == user.email) {
          group = formGroup;
          break;
        }
      }
      this.addEditUserInfoRow(user, group);
    }
    if (this.table && this.userRows)
      this.table.renderRows();
    console.log('capabilities', this.userInfo, this.userRows);
  }

  addEditUserInfoRow(userRow : UserRow, group? : UntypedFormGroup) {
    console.log('Entering addEditUserInfoRow', userRow, group);
    if (!group) {
      group = new UntypedFormGroup({});
      group.addControl('email', new UntypedFormControl(userRow.email));
      group.addControl('teamRole', new UntypedFormControl(userRow.teamRole));
      group.addControl('capabilities', new UntypedFormControl(userRow.capabilities));
      this.userFormArray.push(group);
    } else {
      group.controls['email'].setValue(userRow.email);
      group.controls['teamRole'].setValue(userRow.teamRole);
      group.controls['capabilities'].setValue(userRow.capabilities);
    }
  }

  toUserValue(s : string) {
    let splitArr : string[] = s.split('_');
    const ret : string = splitArr.map(word => word.charAt(0).toUpperCase() + word.substring(1).toLowerCase()
    ).join(' ');
    //console.log('toUserValue',ret);
    return ret;
  }
  

  toEnumValue (s : string) {
    return s && s != null ? s.toUpperCase().replace(' ', '_').replace(' ', '_') : s;
  }

  getTeamMembers(group? : PractitionerGroupEntity ) : TeamMember[] {
    //console.log('getTeamMembers', this.userInfo);
    let ret : TeamMember[] = [];
    for (let i = 0; i < this.userInfo.length; i++) {
      let teamRole : string = this.toEnumValue(this.getControl(i, 'teamRole').value);
      if (teamRole != 'NOT_IN_TEAM') {
        let capabilities : ServiceLevelService[] = this.getControl(i, 'capabilities').value;
        let email : string = this.getControl(i, 'email').value;
        let existing : TeamMember = this.teamMembers.find(tm => tm.email === email);
        ret.push({
          id : existing ? existing.id : undefined,
          email : email,
          groupId : group ? group.id : undefined,
          teamRole : teamRole,
          capabilities: capabilities,
        });
      }
    }

    //console.log('getTeamMembers', ret);
    return ret;
  }

  getWorkHours(group : PractitionerGroupEntity) : WorkHoursList {
    
    let startTimeSecs : number = dayTimeToSeconds(this.practitionerGroupForm.value.startTime);
    let endTimeSecs : number = dayTimeToSeconds(this.practitionerGroupForm.value.endTime);
    let daysOfWeek : string[] = this.practitionerGroupForm.value.workDays;
    let workingHours : TeamWorkingHours[] = [].concat(daysOfWeek.map(d => ({
      teamId : group.id,
      dayOfWeek: DayOfWeek[d],
      startTimeSecs : startTimeSecs,
      endTimeSecs : endTimeSecs
    })));
    console.log('getWorkHours 1', workingHours, daysOfWeek);
    for (let dt of this.practitionerGroupForm.value.holidays) {
     workingHours.push({
        teamId : group.id,
        epochDay:Math.floor(dt/8.64e7),
        startTimeSecs : startTimeSecs,
        endTimeSecs : endTimeSecs
      });
    }
    console.log('getWorkHours 2', workingHours);
    return {
      workingHours : workingHours
    };
  }

  getTeamUsers() : string[] {
    return this.practitionerGroupForm.value.users;
  }

  isFormInValid() {
    const currentTeamRoles : string[] = this.getTeamMembers().map(tm => tm.teamRole);
    

    return (
      (currentTeamRoles.indexOf('Worker') > -1 && currentTeamRoles.indexOf('Evaluator') > -1) &&
      this.practitionerGroupForm.controls.name.invalid 
      && this.practitionerGroupForm.controls.description.invalid 
      && this.practitionerGroupForm.controls.coordinator.invalid 
      && this.practitionerGroupForm.controls.workDays.invalid 
      && this.practitionerGroupForm.controls.startTime.invalid 
      && this.practitionerGroupForm.controls.endTime.invalid 
    );
  }

  onSubmitForm(treatmentForm) {
   this.save();
  }

  close() {
      this.dialogRef.close();
      this.closed = true;
  }

  getTeamRoles() {
    let ret : string[] = [].concat(this.teamRoles);
    this.displayColumns = ['email', 'teamRole'];
    const current : string[] = this.getTeamMembers().map(tm => tm.teamRole ? tm.teamRole.toLowerCase().replace('_', ' ') : '');
    let splice : number = -1;
    if (current.indexOf('worker') > -1) {
      splice = ret.indexOf('Evaluator');
      this.displayColumns = ['email', 'teamRole', 'capabilities'];
    }
    if (current.indexOf('evaluator') > -1) {
      splice = ret.indexOf('Worker');
    }
    if (splice > -1) {
      ret.splice(splice, 1);
    }
    //console.log('getTeamRoles', this.teamRoles, ret, splice, current);
    return ret;
  }


  save() {
      const groupusers : GroupUser[] = this.getTeamMembers().map(tm => ({
        email: tm.email,
        role: tm.teamRole
      }));

      
      console.log('entering save', this.practitionerGroupForm.value.users);
      let g : PractitionerGroupEntity = ({
        id: (this.edited.id && this.edited.id > -1) ? this.edited.id : null,
        name : this.practitionerGroupForm.value.name,
        description :  this.practitionerGroupForm.value.description,
        groupUsers : groupusers, 
        createdBy : this.common.getCurrentUserToView(),
        providerId : this.provider.id,
        children : [],
        families: this.data.families && this.data.families.length > 0 && this.data.families[0] != null ? [].concat(this.data.families) : []
      });
    console.log('Practitioner group to save', g);  

    this.store.dispatch(new SavePractitionerGroup(g));
    interval(2000).pipe(take(1)).subscribe(t => {
        CommunityConfigService.teamsLoaded =false;
          this.store.dispatch(new GetPractitionerGroups(this.provider.id));
          this.store.dispatch(new GetTeamsForUser());
        });
    this.saveFired = true;    
  }
  public dateClass = (date: Date) => {
    if (this._findDate(date) !== -1) {
      return [ 'selected' ];
    }
    return [ ];
  }

  public dateChanged(event: MatDatepickerInputEvent<Date>): void {
    if (event.value) {
      const date = event.value;
      const model = this.getHolidays();
      const index = this._findDate(date);
      if (index === -1) {
        model.push(date);
      } else {
        model.splice(index, 1)
      }
      this.resetModel = new Date(0);
      if (!this.CLOSE_ON_SELECTED && this._picker) {
        const closeFn = this._picker.close;
        this._picker.close = () => { };
        this._picker['_popupComponentRef'].instance._calendar.monthView._createWeekCells()
        setTimeout(() => {
          this._picker.close = closeFn;
        });
      }
      this.practitionerGroupForm.controls.holidays.setValue(model);
    }
  }

  public remove(date: Date): void {
    const index = this._findDate(date);
    const model = this.getHolidays();
    model.splice(index, 1);
    this.practitionerGroupForm.controls.holidays.setValue(model);
  }

  private _findDate(date: Date): number {
    return  this.getHolidays().map((m) => +m).indexOf(+date);
  }

  getHolidays() : Date[] {
    return this.practitionerGroupForm.value.holidays;
  }

  getStartTimeList() : string[] {
    const endTime : string = this.practitionerGroupForm.value.endTime;
    const idx : number = this.workHours.indexOf(endTime);
    return (idx === -1) ? this.workHours : this.workHours.slice(0, idx);
  }

  getEndTimeList() : string[] {
    const startTime : string = this.practitionerGroupForm.value.startTime;
    const idx : number = this.workHours.indexOf(startTime);
    return (idx === -1) ? this.workHours : this.workHours.slice(idx+1);
  }

  onNext() {
    this.panel++;
    console.log(this.panel);
  }

  onPrevious() {
      this.panel--;
  }

  getUsers() : string[] {
    let teamUsers : string[] =  this.practitionerGroupForm.value.users;
    if (null === teamUsers) {
      return [];
    }

    return this.provider.users
          .map(user => user.email.value)
          .filter(user => teamUsers.indexOf(user) > -1)
          .sort();
  }

  getServiceLevelName(serviceLevelId : number) {
    let ret : string = '';
    const filtered : ServiceLevel[] =  this.serviceLevels.filter(sl => sl.id == serviceLevelId);
    if (filtered.length > 0) {
      ret = filtered[0].name;
    }
    return ret;
  }

  getServices(): ServiceLevelService[] {
    let ret : ServiceLevelService[] = [];
    if (!this.teamMembers)
      return [];
    //console.log('getServices', this.serviceLevels);
    for (let sl of this.serviceLevels) {
      for (let service of sl.services) {
        ret.push({
          name : service.name,
          groupId : this.teamMembers && this.teamMembers.length > 0 ? this.teamMembers[0].groupId : undefined,
          serviceLevelId : sl.id,
          id: service.id
          
        });
      }
    }
    return ret;
  }

  isEvaluationTeam() : boolean {
    return this.getTeamRoles().indexOf('Evaluator') > -1 ;
  }


  get userInfo() {
    return this.userFormArray.controls as UntypedFormGroup[];
  }

  getControl(index:number,name:string)
  {
    return this.userFormArray.at(index).get(name) as UntypedFormControl
  }

}

export interface PractitionerGroup {
  id : number;
  name: string;
  description: string;
  users: string[];
}

export interface UserRow {
  email : string;
  teamRole : string;
  capabilities : ServiceLevelService[];
}